import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import capitalize from 'lodash/capitalize';
import isUndefined from 'lodash/isUndefined';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormattedAddress } from '../../../../../../onboarding-business-insight.types';
import SubmittedVerified from './components/submitted-verified';
type AddressCardProps = {
  address: FormattedAddress;
  isSelected: boolean;
  onSelect: (address: FormattedAddress) => void;
};
const AddressCard = forwardRef<HTMLButtonElement, AddressCardProps>((t0, ref) => {
  const $ = _c(51);
  const {
    address,
    isSelected,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    id,
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode,
    propertyType,
    submitted,
    deliverable,
    verified
  } = address;
  let t2;
  if ($[1] !== deliverable || $[2] !== propertyType) {
    t2 = !propertyType || !isUndefined(deliverable);
    $[1] = deliverable;
    $[2] = propertyType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const showNotes = t2;
  let t3;
  if ($[4] !== address || $[5] !== id || $[6] !== onSelect) {
    t3 = () => {
      const card = document.getElementById(`offices-card-${id}`);
      const parent = card?.parentElement;
      if (card && parent) {
        parent.scrollTo({
          top: card.offsetTop,
          behavior: "smooth"
        });
      }
      onSelect(address);
    };
    $[4] = address;
    $[5] = id;
    $[6] = onSelect;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSelect = t3;
  const formatAddressLine = _temp2;
  let t4;
  if ($[8] !== t) {
    t4 = text => <p className="text-body-2 text-tertiary">{t(_temp3)} · {text}</p>;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getUspsText = t4;
  const t5 = `offices-card-${id}`;
  const t6 = isSelected ? "border-secondary" : "border-tertiary hover:border-primary hover:bg-hover";
  let t7;
  if ($[10] !== t6) {
    t7 = cx("w-full relative flex flex-col border border-solid rounded bg-primary cursor-pointer transition-colors duration-100 ease-in-out box-border", t6);
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== submitted || $[13] !== verified) {
    t8 = <SubmittedVerified submitted={submitted} verified={verified} />;
    $[12] = submitted;
    $[13] = verified;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = isSelected ? "text-primary" : "text-tertiary";
  let t10;
  if ($[15] !== t9) {
    t10 = cx("text-label-2", t9);
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== addressLine1 || $[18] !== addressLine2) {
    t11 = formatAddressLine([addressLine1, addressLine2]);
    $[17] = addressLine1;
    $[18] = addressLine2;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <p className={t10}>{t11}</p>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = !isSelected && "text-tertiary";
  let t14;
  if ($[23] !== t13) {
    t14 = cx("text-body-2", t13);
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== city || $[26] !== postalCode || $[27] !== state) {
    t15 = formatAddressLine([city, state, postalCode]);
    $[25] = city;
    $[26] = postalCode;
    $[27] = state;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <p className={t14}>{t15}</p>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t16) {
    t17 = <div className="flex flex-col">{t12}{t16}</div>;
    $[32] = t12;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== deliverable || $[36] !== getUspsText || $[37] !== propertyType || $[38] !== showNotes || $[39] !== t) {
    t18 = showNotes && <div className="flex flex-col"><p className="text-label-2 text-tertiary">{t(_temp4)}</p>{!isUndefined(propertyType) && getUspsText(capitalize(propertyType))}{!isUndefined(deliverable) && getUspsText(deliverable ? t(_temp5) : t(_temp6))}</div>;
    $[35] = deliverable;
    $[36] = getUspsText;
    $[37] = propertyType;
    $[38] = showNotes;
    $[39] = t;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t17 || $[42] !== t18 || $[43] !== t8) {
    t19 = <div className="flex flex-col w-full gap-2 p-3 text-left">{t8}{t17}{t18}</div>;
    $[41] = t17;
    $[42] = t18;
    $[43] = t8;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== handleSelect || $[46] !== ref || $[47] !== t19 || $[48] !== t5 || $[49] !== t7) {
    t20 = <button id={t5} ref={ref} className={t7} onClick={handleSelect} type="button">{t19}</button>;
    $[45] = handleSelect;
    $[46] = ref;
    $[47] = t19;
    $[48] = t5;
    $[49] = t7;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  return t20;
});
export default AddressCard;
function _temp(field) {
  return Boolean(field);
}
function _temp2(addressFields) {
  return addressFields.filter(_temp).join(", ");
}
function _temp3($) {
  return $.offices.usps;
}
function _temp4($_0) {
  return $_0.offices.notes;
}
function _temp5($_1) {
  return $_1.offices.deliverable;
}
function _temp6($_2) {
  return $_2.offices.notDeliverable;
}